function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { devMessage } from "../../../utils";
import React, { useEffect, useMemo, useState } from "react";
import { AlertBase } from "../AlertBase/AlertBase";
import { useStyle } from "./UserAlert.styles";
var MINIMUM_TIMEOUT = 4000;
var UserAlert = function(_param) {
    var dismissInterval = _param.dismissInterval, onDismiss = _param.onDismiss, accessibilityLabel = _param.accessibilityLabel, _appearance = _param.appearance, appearance = _appearance === void 0 ? 'info' : _appearance, _isPositionFixed = _param.isPositionFixed, isPositionFixed = _isPositionFixed === void 0 ? true : _isPositionFixed, content = _param.content, _dismissible = _param.dismissible, dismissible = _dismissible === void 0 ? true : _dismissible, dismissButtonAriaLabel = _param.dismissButtonAriaLabel, action = _param.action, _isRtl = _param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, id = _param.id, isVisibleProp = _param.isVisible, propDrop = _objectWithoutProperties(_param, [
        "dismissInterval",
        "onDismiss",
        "accessibilityLabel",
        "appearance",
        "isPositionFixed",
        "content",
        "dismissible",
        "dismissButtonAriaLabel",
        "action",
        "isRtl",
        "id",
        "isVisible"
    ]);
    var styles = useStyle({
        appearance: appearance,
        dismissible: dismissible,
        isRtl: isRtl,
        isPositionFixed: isPositionFixed
    });
    var ref = _slicedToArray(useState(true), 2), isVisible = ref[0], setIsVisible = ref[1];
    var _onDismiss = function() {
        setIsVisible(false);
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(id);
    };
    var timeToDismiss = useMemo(function() {
        if (!Number.isInteger(dismissInterval)) {
            return MINIMUM_TIMEOUT;
        }
        if (typeof dismissInterval !== 'undefined' && dismissInterval < MINIMUM_TIMEOUT) {
            devMessage("You have passed in a dismissInterval prop to your UserAlert less than 4000ms (".concat(dismissInterval, "). That is not sufficient time for auto dismissing content. It has been set to 4 seconds (4000ms)."));
            return MINIMUM_TIMEOUT;
        }
        return dismissInterval;
    }, [
        dismissInterval
    ]);
    useEffect(function() {
        var onDismissTimer = null;
        if (onDismiss && (appearance !== 'danger' && (dismissInterval || !dismissible || dismissInterval === 0) || !dismissInterval && !dismissible)) {
            onDismissTimer = setTimeout(_onDismiss, timeToDismiss);
        }
        return function() {
            if (onDismissTimer) {
                clearTimeout(onDismissTimer);
            }
        };
    }, []);
    return _jsx(AlertBase, _objectSpread({
        accessibilityLabel: accessibilityLabel,
        accessibilityLive: "polite",
        accessibilityRole: appearance === 'danger' ? 'alert' : 'status',
        appearance: appearance,
        dismissible: dismissible,
        dismissButtonAriaLabel: dismissButtonAriaLabel,
        action: action,
        isRtl: isRtl
    }, propDrop, {
        id: id,
        onDismiss: _onDismiss,
        isVisible: isVisibleProp !== null && isVisibleProp !== void 0 ? isVisibleProp : isVisible,
        styles: styles,
        content: content
    }));
};
export { UserAlert };
